import { render, staticRenderFns } from "./StateColumn.vue?vue&type=template&id=51947f1c&scoped=true"
import script from "./StateColumn.ts?vue&type=script&lang=ts&external"
export * from "./StateColumn.ts?vue&type=script&lang=ts&external"
import style0 from "./StateColumn.vue?vue&type=style&index=0&id=51947f1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51947f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51947f1c')) {
      api.createRecord('51947f1c', component.options)
    } else {
      api.reload('51947f1c', component.options)
    }
    module.hot.accept("./StateColumn.vue?vue&type=template&id=51947f1c&scoped=true", function () {
      api.rerender('51947f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/list/columns/StateColumn/StateColumn.vue"
export default component.exports